export function isFullPage(appearance) {
  return appearance === 'full-page' || appearance === 'full-width';
}